import { render } from "./App.vue?vue&type=template&id=bf9456e0"
const script = {}

import "./assets/workspace.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__